'use client';

import { lazy, Suspense } from 'react';
import MemberSubHeader from '@fe-news/components/molecules/MemberHeader/MemberSubHeader';
import { NewsCategory } from '@fe-news/constants/categories';
import DateProvider from '@fe-news/context/date-provider';
import PortfoliosNewsContentSkeleton from '@fe-news/components/organisms/PortfoliosNewsContent/PortfoliosNewsContentSkeleton';

const PortfoliosNewsContentLazy = lazy(() => import('@fe-news/components/organisms/PortfoliosNewsContent'));

const PortfoliosNews = () => {
  return (
    <DateProvider category={NewsCategory.MY_TAG}>
      <Suspense
        fallback={
          <>
            <MemberSubHeader category={NewsCategory.PORTFOLIOS} />
            <PortfoliosNewsContentSkeleton />
          </>
        }
      >
        <MemberSubHeader category={NewsCategory.PORTFOLIOS} />
        <PortfoliosNewsContentLazy />
      </Suspense>
    </DateProvider>
  );
};

export default PortfoliosNews;
